<div class="stakeholder-user-list">
  <app-stakeholder-user-list-item
    *ngFor="let item of items"
    [label]="item.label"
    (deleteClick)="handleDeleteClick(item)">
  </app-stakeholder-user-list-item>
</div>
